var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 10.6667L7.33334 9.00001L9.00001 7.33334L10.6667 9.00001L9.00001 10.6667ZM7.22918 5.91501L5.48251 4.16834L9.00001 0.650635L12.5175 4.16834L10.7708 5.91501L9.00001 4.14418L7.22918 5.91501ZM4.16834 12.5175L0.650635 9.00001L4.16834 5.48251L5.91501 7.22918L4.14418 9.00001L5.91501 10.7708L4.16834 12.5175ZM13.8317 12.5175L12.085 10.7708L13.8558 9.00001L12.085 7.22918L13.8317 5.48251L17.3494 9.00001L13.8317 12.5175ZM9.00001 17.3494L5.48251 13.8317L7.22918 12.085L9.00001 13.8558L10.7708 12.085L12.5175 13.8317L9.00001 17.3494Z",
    fill: "#90A4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiFillIcon);
export default __webpack_public_path__ + "static/media/api-fill-icon.667f645215e532a6944c1f5f3e72ada3.svg";
export { ForwardRef as ReactComponent };